import { mavonEditor } from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
export default {
  components: {
    mavonEditor
  },
  data() {
    return {
      content: '',
      html: '',
      value: '33333333[33](31)333 <p>33333333<a href="31" target="_blank">33</a>333</p>'
    };
  },
  methods: {
    // 所有操作都会被解析重新渲染
    change(value, render) {
      console.log(value, render);
      // render 为 markdown 解析后的结果[html]
      this.html = render;
    },
    // 提交
    submit() {
      console.log(this.content);
      console.log(this.html);
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg);
        e.preventDefault(); // 阻止默认行为
      };
      const once = {
        once: true
      };
      document.addEventListener('copy', save, once); // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy'); // 执行copy方法
      this.$message({
        message: this.$t('复制成功'),
        type: 'success'
      });
    }
  }
};